<template>
    <div class="form-page" v-if="form != null">
        <div class="container">
            <div class="column-container" :class="{'toManyRequests' : toManySendingMsg}">
                <div class="col-left">
                    <div class="form-titles">
                        <h3>{{form.form_page_title}}</h3>
                        <span>{{form.form_page_desc}}</span>
                    </div>
                </div>
                <div class="col-right">
                    <form class="form_call">
                        <div class="form-in" :class="{fadeOut : !formVisible, 'disabled-form' : formDisabled}" v-if="formVisible">
                            <div class="form-group form-text" :class="{'error' : errors.has('name')}">
                                <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                            </div>
                            <div class="form-group form-phone" :class="{'error' : errors.has('phone')}">
                                <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7 (" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                            </div>
                            <VueRecaptcha  
                                ref="recaptchaFormPage"
                                @verify="onCaptchaVerified"
                                @expired="onCaptchaExpired"
                                :sitekey="salesGcap_siteKey"
                                size="invisible"
                            />
                            <div class="btn-send">
                                <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.send_call_btn_desc}}</button>
                                <span class="error-message" v-show="errors.has('name') || errors.has('phone')">Заполните все поля</span>
                            </div>
                            
                        </div>
                        <div class="successMessage" v-if="!formVisible">
                            <h3>Спасибо! Ваша заявка отправлена.</h3>
                        </div>
                    </form>
                </div>
                <div class="privacy-desc" v-if="formVisible">
                    <p>
                        <span>{{ form.form_privacy_desc.one }}</span> 
                        «<span>{{ form.send_call_btn_desc }}</span>» <br>
                        <span class="two">{{ form.form_privacy_desc.two }}</span>
                        <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{ form.form_privacy_desc.word }}</a></span>
                        <span class="three">{{ form.form_privacy_desc.three }}</span>
                    </p>
                </div>
                <div class="to-many-requests-msg" v-if="toManySendingMsg">
                    <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                    <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
                    <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import { VueRecaptcha } from 'vue-recaptcha';
    import {mapGetters} from 'vuex'
    
    export default {
        name: 'FormConsultLand',
        data () {
            return {
                globalLang: window.GlobalLang, 
                phone: '',
                name: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                formDisabled: false,
                utmUrlParams: {},
                captchaToken: '',
                errorMsg: false,
                toManySendingMsg: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^\+7\s?\((700|701|702|703|704|705|706|707|708|709|747|771|775|776|777|778)\)\s?\d{3}-\d{2}-\d{2}$/,
                }
            }
        },
        components: {
            MaskedInput,
            VueRecaptcha,
        },
        computed: mapGetters({
            form: 'loadForms',
            salesGcap_siteKey: 'loadGcap_sitekey',
        }),
        methods: {
            onCaptchaVerified(response) {
                this.captchaToken = response;
                let submissionCounter = localStorage.getItem('formPage_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('formPage_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                } else {
                    this.getQueryParams(submissionCounter, lastSubmissionTime);
                }
                // console.log(submissionCounter)
                // console.log(response)
                // console.log('start sending verify is complete');
            },
           
            sendData() {
                this.$validator.validate().then(result => {
                    if(result) {
                        this.$refs.recaptchaFormPage.execute();
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            getQueryParams(counter, time) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                for (const [key, value] of urlParams.entries()) {
                    this.utmUrlParams[key] = value;
                }
                this.sendDataCRM(counter, time);
            },
            sendDataCRM(counter, time) {
                this.formDisabled = true;
                var dataForm = {
                    captcha: this.captchaToken,
                    captchaKey: this.salesGcap_siteKey,
                    //
                    leadName: this.name,
                    phone: this.normalizePhone(this.phone),
                    complex: 'Заявка на консультацию с сайта sales.bazis.kz',
                    email: '',
                    advertisingChannel: "Sales", 
                    advertisingChannelCode: "Sales",
                    advertisingChannelName: "sales.bazis.kz",

                    leadChannelCode: 'WEBSITE_REST_PRIVATE_OFFICE',
                    leadChannelName: "Личный кабинет",
                    requestWebsite: 'sales.bazis.kz',

                    description:
                    "Form on page" +
                    (this.utmUrlParams.utm_source ? ` | Utm Source: ${this.utmUrlParams.utm_source}` : '') +
                    (this.utmUrlParams.utm_medium ? ` | Utm Medium: ${this.utmUrlParams.utm_medium}` : '') +
                    (this.utmUrlParams.utm_campaign ? ` | Utm Campaign: ${this.utmUrlParams.utm_campaign}` : '') +
                    (this.utmUrlParams.utm_content ? ` | Utm Content: ${this.utmUrlParams.utm_content}` : '') +
                    (this.utmUrlParams.utm_term ? ` | Utm Term: ${this.utmUrlParams.utm_term}` : ''),

                    utmSource: this.utmUrlParams.utm_source ? this.utmUrlParams.utm_source : '',
                    utmMedium: this.utmUrlParams.utm_medium ? this.utmUrlParams.utm_medium : '',
                    utmCampaign: this.utmUrlParams.utm_campaign ? this.utmUrlParams.utm_campaign : '',
                    utmName: this.utmUrlParams.utm_source ? 'SALES BAZIS' : 'UTM отсутствует - SALES BAZIS',
                    utmContent: this.utmUrlParams.utm_content ? this.utmUrlParams.utm_content : '',
                    utmTerm: this.utmUrlParams.utm_term ? this.utmUrlParams.utm_term : '',
                    utmCode: this.generateUniqueUTMCode(),
                }
                
                this.$store.dispatch('sendFormDataToCRM', dataForm).then((response) => {
                    if (response.status == 200) {
                        this.formVisible = false;
                        counter++;
                        localStorage.setItem('formPage_submissionCounter', counter);
                        localStorage.setItem('formPage_lastSubmissionTime', time);
                        window.dataLayer.push({'event' : 'form_sent'});
                    } else {
                        this.formDisabled = false;
                        this.$refs.recaptchaFormPage.reset();
                        console.warn('Ошибка при отправке формы - обратитесь в Call Center');
                    }
                });
            },
            normalizePhone(phone) {
                const digits = phone.replace(/\D/g, '');
                if (digits.length !== 11 || !digits.startsWith('7')) {
                    return null;
                }
                const code = digits.slice(1, 4);
                const part1 = digits.slice(4, 7);
                const part2 = digits.slice(7, 9);
                const part3 = digits.slice(9, 11);
                return `+7 ${code} ${part1} ${part2} ${part3}`;
            },
            onCaptchaExpired() {
                console.log('capcha expired');
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            generateUniqueUTMCode() {
                const lengthstr = 10;
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
                const charsLength = chars.length

                const array = new Uint8Array(lengthstr)
                crypto.getRandomValues(array)

                let result = ''
                for (let i = 0; i < lengthstr; i++) {
                    result += chars[array[i] % charsLength]
                }
                return result
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-page.scss';
    @import '@/styles/respond/forms/form-page-respond.scss';
</style>